import { render, staticRenderFns } from "./EditSectionsModal.vue?vue&type=template&id=cbcac660"
import script from "./EditSectionsModal.vue?vue&type=script&lang=js"
export * from "./EditSectionsModal.vue?vue&type=script&lang=js"
import style0 from "./EditSectionsModal.vue?vue&type=style&index=0&id=cbcac660&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports